import {useDeepCompareEffect, useSelections, useUpdateEffect} from "../../../../__snowpack__/pkg/ahooks.js";
import {Checkbox, Col, Row} from "../../../../__snowpack__/pkg/antd.js";
import React, {useRef} from "../../../../__snowpack__/pkg/react.js";
import {useIntl} from "../../../../__snowpack__/pkg/react-intl.js";
export default function CheckboxGroup(props) {
  const {value = [], onChange, id, options = [], showAllSelect = false, ignoreDisabledOptions = false} = props;
  const {formatMessage} = useIntl();
  const {selected, allSelected, setSelected, isSelected, toggle, toggleAll, partiallySelected} = useSelections((ignoreDisabledOptions ? options.filter((option) => typeof option !== "object" ? true : !option.disabled) : options).map((option) => typeof option !== "object" ? option : option?.value), value);
  const ref = useRef({isInternalChange: false});
  useDeepCompareEffect(() => {
    setSelected(value);
  }, [value]);
  useUpdateEffect(() => {
    if (ref.current.isInternalChange) {
      onChange?.(selected);
      ref.current.isInternalChange = false;
    }
  }, [selected]);
  return /* @__PURE__ */ React.createElement(Row, {
    id
  }, showAllSelect && /* @__PURE__ */ React.createElement(Col, {
    style: {lineHeight: "28px"}
  }, /* @__PURE__ */ React.createElement(Checkbox, {
    checked: allSelected,
    indeterminate: partiallySelected,
    onClick: () => {
      ref.current.isInternalChange = true;
      toggleAll();
    }
  }, formatMessage({id: "all"}))), options.map((option) => {
    const {
      label,
      value: optionValue,
      ...restProps
    } = typeof option === "object" ? option : {label: option, value: option};
    return /* @__PURE__ */ React.createElement(Col, {
      key: String(optionValue),
      style: {lineHeight: "28px"}
    }, /* @__PURE__ */ React.createElement(Checkbox, {
      ...restProps,
      checked: isSelected(optionValue),
      onClick: () => {
        ref.current.isInternalChange = true;
        toggle(optionValue);
      }
    }, label));
  }));
}
